import React, { useEffect, useState } from "react";
import { images } from "../../../config/images";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import CustomDatePicker from "./DateRangePicker";
import PieChart from "../PieLineChart/PieChart";
import PeriodBarChart from "./PeriodBarChart";
import { Button } from "../../Button/button";
import BarChart from "../PieLineChart/BarChart";
import { getProductOverProductBarGraph } from "../../../container/Pipes/services";
import PeriodCustomDatePicker from "./DateRangePicker";

const PeriodOverPeriod = ({
  type,
  productData,
  sizeData,
  locationData,
  userRoleList,
  isFilterOpen,
  setIsFilterOpen,
}) => {
  const [selectedChart, setSelectedChart] = useState("pie");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [statusChoice, setStatusChoice] = useState("Counterfeit"); // Add this state
  const [filterType, setFilterType] = useState("");
  const [productIds, setProductIds] = useState([]);
  const [sizeIds, setSizeIds] = useState([]);
  const [locationIds, setLocationIds] = useState([]);
  const [selectRoleId, setRoleId] = useState([]);
  const [filters, setFilters] = useState({
    android: true,
    ios: true,
  });

  const [firstStartDate, setFirstStartDate] = useState(null);
  const [firstEndDate, setFirstEndDate] = useState(null);
  const [secondStartDate, setSecondStartDate] = useState(null);
  const [secondEndDate, setSecondEndDate] = useState(null);

  // Add these new states at the top with other state declarations
  const [firstPeriodData, setFirstPeriodData] = useState({});
  const [secondPeriodData, setSecondPeriodData] = useState({});

  useEffect(() => {
    if (sizeData.length > 0) {
      const defaultSelected = sizeData.find((item) => item.size === "3/4");
      if (defaultSelected) {
        setSizeIds([defaultSelected]);
      }
    }
  }, [sizeData]);


  useEffect(() => {
    if (locationData?.length > 0) {
      setLocationIds(
        locationData.map((item) => ({
          id: item.id,
          location: item.location,
        }))
      );
    }
  }, [locationData]);
  useEffect(() => {
    if (userRoleList.length > 0) {
      setRoleId(
        userRoleList.map((role) => ({
          id: role.id,
          name: role.name,
        }))
      );
    }
  }, [userRoleList]);

  // Update the fetchData function
  const fetchData = async () => {
    try {
      // Fetch first period data
      const firstPeriodParams = buildParams(
        getProductOverProductBarGraph,
        true
      );
      const firstPeriodResp = await getProductOverProductBarGraph(
        firstPeriodParams
      );

      // Fetch second period data
      const secondPeriodParams = buildParams(
        getProductOverProductBarGraph,
        false
      );
      const secondPeriodResp = await getProductOverProductBarGraph(
        secondPeriodParams
      );

      if (firstPeriodResp.status === 200) {
        setFirstPeriodData(firstPeriodResp.data.payload);
      }

      if (secondPeriodResp.status === 200) {
        setSecondPeriodData(secondPeriodResp.data.payload);
      }
    } catch (error) {
      setFirstPeriodData({});
      setSecondPeriodData({});
    }
  };

  const formatDate = (date, isEndDate = false) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const time = isEndDate ? "23:59:59" : "00:00:00";
    return `${year}-${month}-${day} ${time}`;
  };

  // By default set startDate and endDate to 7 days ago and today
  // Update useEffect for default dates
  useEffect(() => {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - 6);

    // Set second period
    setSecondStartDate(formatDate(start, false));
    setSecondEndDate(formatDate(end, true));

    // Set first period (previous 7 days)
    const firstEnd = new Date(start);
    firstEnd.setDate(start.getDate() - 1); // End one day before second period starts
    const firstStart = new Date(firstEnd);
    firstStart.setDate(firstEnd.getDate() - 6); // Go back 7 days from first end date

    setFirstStartDate(formatDate(firstStart, false));
    setFirstEndDate(formatDate(firstEnd, true));
  }, []);

  // Set default selectfirst product
  useEffect(() => {
    if (productData?.length > 0 && productIds?.length === 0) {
      setProductIds([
        {
          id: productData[0].id,
          product_name: productData[0].product_name,
        },
      ]);
    }
  }, [productData]);

  const handleFilterChange = (filterName) => (event) => {
    setFilters({ ...filters, [filterName]: event.target.checked });
  };

  const handleFilterRoleChange = (roleId) => (event) => {
    if (event.target.checked) {
      const selectedRole = userRoleList.find((role) => role.id === roleId);
      setRoleId([
        ...selectRoleId,
        {
          id: selectedRole.id,
          name: selectedRole.name,
        },
      ]);
    } else {
      setRoleId(selectRoleId.filter((role) => role.id !== roleId));
    }
  };
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    const selectedItems = productData.filter((item) =>
      value.includes(item.product_name)
    );

    setProductIds(
      selectedItems.map((item) => ({
        id: item.id,
        product_name: item.product_name,
      }))
    );
  };
  const handlelocationChange = (event) => {
    const {
      target: { value },
    } = event;

    const selectedLocations = locationData.filter((item) =>
      value.includes(item.location)
    );

    setLocationIds(
      selectedLocations.map((item) => ({
        id: item.id,
        location: item.location,
      }))
    );
  };
  const handleChangeSize = (event) => {
    const {
      target: { value },
    } = event;

    const selectedItem = sizeData.find((item) => item.size === value);

    if (selectedItem) {
      setSizeIds([{
        id: selectedItem.id,
        size: selectedItem.size,
      }]);
    }
  };
  const handleDateSelect = (range) => {
    setFirstStartDate(range.firstStart);
    setFirstEndDate(range.firstEnd);
    setSecondStartDate(range.secondStart);
    setSecondEndDate(range.secondEnd);
    setShowDatePicker(false);
  };

  const handleFilterClick = () => {
    setFilterType(type);
    setIsFilterOpen(true);
  };

  const handleFilterSubmit = () => {
    setIsFilterOpen(false);
    if (sizeIds.length > 0) {
      fetchData();
    }
  };

  const buildParams = (apiCall, isFirstPeriod = true) => {
    const params = {
      product_id: productIds.map((item) => item.id),
      start_date: isFirstPeriod ? firstStartDate : secondStartDate,
      end_date: isFirstPeriod ? firstEndDate : secondEndDate,
      location_name: locationIds.map((item) => item.location),
      scan_by: selectRoleId.map((item) => item.id),
      size: sizeIds.map((item) => item.id),
      device_types: [filters.android ? 0 : filters.ios ? 1 : null].filter(
        (type) => type !== null
      ),
      status_choice: statusChoice === "Cross Selling" ? 2 : 3,
    };
    return params;
  };

  useEffect(() => {
    if (
      firstStartDate &&
      firstEndDate &&
      secondStartDate &&
      secondEndDate &&
      statusChoice
    ) {
      if (sizeIds.length > 0) {
        fetchData();
      }
    }
  }, [
    firstStartDate,
    firstEndDate,
    secondStartDate,
    secondEndDate,
    statusChoice,
    selectRoleId,
    productIds
  ]);

  return (
    <Box className="product-over-product">
      <Box>
        <Grid container spacing={2}>
          <Grid item size={{ xs: 12, md: 8 }} className="bar-chart-grid">
            {firstPeriodData?.daily_size_data?.length > 0 &&
              secondPeriodData?.daily_size_data?.length > 0 ? (
              <PeriodBarChart
                firstPeriodData={firstPeriodData}
                secondPeriodData={secondPeriodData}
                selectedSize={sizeIds[0].size}
              />
            ) : (
              <div className="no-data-container">
                <img
                  src={images.noDataFoundImg}
                  className="no-data-img"
                  alt="No Data Found"
                />
              </div>
            )}
          </Grid>
          <Grid item size={{ xs: 12, md: 4 }} className="pie-chart-grid">
            <Box className="chart-controls">
              <div className="chart-type-selector">
                <div className="chart-type-selector">
                  <img
                    src={
                      selectedChart === "pie"
                        ? images.pieChartBgImg
                        : images.pieChart
                    }
                    alt=""
                    className="graph-type-box chart-box"
                    style={{ cursor: "pointer" }}
                    onClick={() => setSelectedChart("pie")}
                  />
                  <img
                    src={
                      selectedChart === "bar"
                        ? images.barChartBgImg
                        : images.barChart
                    }
                    alt=""
                    className="graph-type-box chart-box"
                    style={{ cursor: "pointer" }}
                    onClick={() => setSelectedChart("bar")}
                  />
                </div>
              </div>
              <div className="chart-filter-controls">
                <select
                  className="chart-select"
                  value={statusChoice}
                  onChange={(e) => setStatusChoice(e.target.value)}
                >
                  <option>Counterfeit</option>
                  <option>Cross Selling</option>
                </select>

                <div className="chart-icons">
                  <div className="calendar-wrapper">
                    <img
                      src={images.calendarIcon}
                      alt="Calendar"
                      className="control-icon"
                      onClick={() => setShowDatePicker(!showDatePicker)}
                    />
                    <div className="date-picker-container">
                      {showDatePicker && (
                        <PeriodCustomDatePicker
                          onSelect={(ranges) => {
                            handleDateSelect(ranges);
                          }}
                          firstStartDate={firstStartDate}
                          firstEndDate={firstEndDate}
                          secondStartDate={secondStartDate}
                          secondEndDate={secondEndDate}
                          onClose={() => {
                            console.log("Picker closed");
                          }}
                          setShowDatePicker={setShowDatePicker}
                          setFirstStartDate={setFirstStartDate}
                          setFirstEndDate={setFirstEndDate}
                        />
                      )}
                    </div>
                  </div>
                  <div style={{ position: "relative" }}>
                    {isFilterOpen && (
                      <div
                        className="filter-backdrop"
                        onClick={() => setIsFilterOpen(false)}
                      />
                    )}
                    <div className="filter-selection-wrapper">
                      <button className="product-filter-button">
                        <img
                          src={images.filter}
                          alt=""
                          className="filter-icon"
                          onClick={() => handleFilterClick()}
                        />
                      </button>
                      {isFilterOpen && (
                        <div className="pop-filter-dropdown">
                          <Box className="product-filter-title">Filters</Box>
                          <FormGroup className="filter-popup-checkbox">
                            <Box className="products-selection">
                              <FormControl sx={{ marginBottom: 2, width: 300 }}>
                                <InputLabel>Products</InputLabel>
                                <Select
                                  multiple
                                  value={productIds.map(
                                    (item) => item.product_name
                                  )}
                                  onChange={handleChange}
                                  input={<OutlinedInput label="Products" />}
                                  renderValue={(selected) => selected.join(", ")}
                                  sx={{ "& .MuiSelect-select": { padding: 1 } }}
                                  MenuProps={{ PaperProps: { style: { maxHeight: 200 }, ref: (el) => { if (el) el.scrollTop = 0; } } }}
                                >
                                  <MenuItem value="all" sx={{ p: 0 }}>
                                    <Checkbox
                                      checked={
                                        productIds.length === productData.length
                                      }
                                      onChange={() => {
                                        if (
                                          productIds.length === productData.length
                                        ) {
                                          setProductIds([]);
                                        } else {
                                          setProductIds(
                                            productData.map((item) => ({
                                              id: item.id,
                                              product_name: item.product_name,
                                            }))
                                          );
                                        }
                                      }}
                                    />
                                    <ListItemText primary="Select All" />
                                  </MenuItem>
                                  {productData.map((item) => (
                                    <MenuItem
                                      key={item.id}
                                      value={item.product_name}
                                      sx={{ p: 0 }}
                                    >
                                      <Checkbox
                                        checked={productIds.some(
                                          (cat) => cat.id === item.id
                                        )}
                                      />
                                      <ListItemText primary={item.product_name} />
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Box>

                            <Box className="size-selection">
                              <FormControl sx={{ marginBottom: 2, width: 300 }}>
                                <InputLabel>Size</InputLabel>
                                <Select
                                  value={sizeIds[0]?.size || ""}
                                  onChange={handleChangeSize}
                                  input={<OutlinedInput label="Size" />}
                                  sx={{
                                    "& .MuiSelect-select": {
                                      padding: 1,
                                    },
                                  }}
                                  MenuProps={{ PaperProps: { style: { maxHeight: 200 }, ref: (el) => { if (el) el.scrollTop = 0; } } }}
                                >
                                  {sizeData.map((item) => (
                                    <MenuItem
                                      key={item.id}
                                      value={item.size}
                                      sx={{ p: 1 }}
                                    >
                                      {filterType === "Product" ? (
                                        <Checkbox
                                          checked={sizeIds.some(
                                            (cat) => cat.id === item.id
                                          )}
                                        />
                                      ) : null}
                                      <ListItemText primary={item.size} />
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Box>

                            <Box className="location-selection">
                              <FormControl sx={{ marginBottom: 2, width: 300 }}>
                                <InputLabel>Location</InputLabel>
                                <Select
                                  multiple
                                  value={locationIds.map((item) => item.location)}
                                  onChange={handlelocationChange}
                                  input={<OutlinedInput label="Location" />}
                                  renderValue={(selected) => selected.join(", ")}
                                  sx={{ "& .MuiSelect-select": { padding: 1 } }}
                                  MenuProps={{ PaperProps: { style: { maxHeight: 200 }, ref: (el) => { if (el) el.scrollTop = 0; } } }}
                                >
                                  <MenuItem value="all" sx={{ p: 0 }}>
                                    <Checkbox
                                      checked={
                                        locationIds.length === locationData.length
                                      }
                                      onChange={() => {
                                        if (
                                          locationIds.length ===
                                          locationData.length
                                        ) {
                                          setLocationIds([]);
                                        } else {
                                          setLocationIds(
                                            locationData.map((item) => ({
                                              id: item.id,
                                              location: item.location,
                                            }))
                                          );
                                        }
                                      }}
                                    />
                                    <ListItemText primary="Select All" />
                                  </MenuItem>
                                  {locationData.map((item) => (
                                    <MenuItem
                                      key={item.id}
                                      value={item.location}
                                      sx={{ p: 0 }}
                                    >
                                      <Checkbox
                                        checked={locationIds.some(
                                          (cat) => cat.id === item.id
                                        )}
                                      />
                                      <ListItemText primary={item.location} />
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Box>

                            <Box className="">
                              <Box className="product-section-title">
                                Scan By:
                              </Box>
                              {userRoleList.map((role) => {
                                const roleKey = role?.id; // Normalize the key
                                return (
                                  <FormControlLabel
                                    key={role.id}
                                    control={
                                      <Checkbox
                                        checked={selectRoleId.some(
                                          (selectedRole) =>
                                            selectedRole.id === role.id
                                        )}
                                        onChange={handleFilterRoleChange(role.id)}
                                        size="small"
                                      />
                                    }
                                    label={role.name}
                                  />
                                );
                              })}
                            </Box>

                            <Box className="">
                              <Box className="product-section-title">Device:</Box>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={filters.android}
                                    onChange={handleFilterChange("android")}
                                    size="small"
                                  />
                                }
                                label="Android"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={filters.ios}
                                    onChange={handleFilterChange("ios")}
                                    size="small"
                                  />
                                }
                                label="iOS"
                              />
                            </Box>

                            <Button
                              onClick={() => handleFilterSubmit()}
                              title="Submit"
                              classname={"custom-button"}
                            />
                          </FormGroup>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Box>
            <Box className="chart-chart">
              {firstPeriodData?.daily_size_data?.length > 0 &&
                secondPeriodData?.daily_size_data?.length > 0 ? (
                selectedChart === "pie" ? (
                  <PieChart
                    label="Period Over Period"
                    firstPeriodData={firstPeriodData}
                    secondPeriodData={secondPeriodData}
                    statusChoice={statusChoice}
                    sizeData={sizeData}
                  />
                ) : (
                  <BarChart
                    label="Period Over Period"
                    firstPeriodData={firstPeriodData}
                    secondPeriodData={secondPeriodData}
                    sizeData={sizeData}
                  />
                )
              ) : (
                <div className="no-data-container">
                  <img
                    src={images.noDataFoundImg}
                    className="no-data-img"
                    alt="No Data Found"
                  />
                </div>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default PeriodOverPeriod;
